<template>
  <v-dialog :fullscreen="$vuetify.breakpoint.smAndDown" v-model="dialog" width="600" scrollable>
    <v-card>
      <v-card-title class="primary white--text text-uppercase">
        Thêm điểm danh đến
        <v-spacer></v-spacer>
        <v-btn dark icon>
          <v-icon @click="cancel">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="py-6">
        <v-form ref="form">
          <v-row>
            <v-col cols="12">
              <DateIOSPicker
                label="Ngày"
                :date.sync="datetime"
                outlined
                class="required"
                :rules="[$rules.required, $rules.date, $rules.dateFromNow]"
                dense
              />
            </v-col>
            <v-col cols="12">
              <CheckboxAcademicLevel :isDefaultCheckAll="false" @change="academicLevelChanged" />
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete
                no-data-text="Danh sách rỗng"
                :items="typeList"
                item-text="title"
                item-value="value"
                v-model="type"
                label="Loại cán bộ"
                outlined
                class="mb-0"
                clearable
                hide-details
                dense
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="6">
              <AutocompleteSubjectGroup
                clear-icon="mdi-close"
                v-model="subjectGroup"
                label="Lĩnh vực"
                item-text="title"
                outlined
                dense
                return-object
                deletable-chips
                hide-details
                @change="subjectGroupChanged"
              />
            </v-col>
            <v-col cols="12">
              <AutocompleteTeacherCard
                ref="selectForm"
                :syncedValue.sync="teacher"
                item-text="name"
                clear-icon="mdi-close"
                label="Giáo viên"
                outlined
                dense
                deletable-chips
                hide-details="auto"
                :rules="[$rules.required]"
                :filter="teacherFilter"
              />
            </v-col>
            <v-col cols="12" class="d-flex flex-row align-center">
              <div class="mr-2">Giờ đến (24h) <span class="error--text">*</span></div>
              <TimeInput
                label="Giờ đến (24h)"
                outlined
                dense
                outline
                class="required"
                :date.sync="time"
                :selectedDate="getCurrentDate"
                :rules="[$rules.required, $rules.time]"
              />
            </v-col>
          </v-row>
        </v-form>
        <CheckinConfirmDialogVue :state="confirmDialog" :type="'in'" @confirm="save" />
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn class="ma-2" outlined light depressed @click="cancel">Hủy</v-btn>
        <v-spacer></v-spacer>
        <v-btn class="ma-2" dark depressed color="#0D47A1" @click="openConfirmDialog">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DateIOSPicker from '@/components/basic/picker/DateIOSPicker.vue'
import TimeInput from '@/components/basic/TimeInput.vue'
import CheckboxAcademicLevel from '../../../modules/academicLevel/CheckboxAcademicLevel.vue'
import AutocompleteSubjectGroup from '../../../components/basic/input/AutocompleteSubjectGroup.vue'
import AutocompleteTeacherCard from '../../../components/basic/input/AutocompleteTeacherCard.vue'
import CheckinConfirmDialogVue from './CheckinConfirmDialog.vue'
import moment from 'moment'
import { get } from 'lodash'
import { mapActions, mapState } from 'vuex'

export default {
  components: {
    DateIOSPicker,
    TimeInput,
    CheckboxAcademicLevel,
    AutocompleteSubjectGroup,
    AutocompleteTeacherCard,
    CheckinConfirmDialogVue,
  },
  data() {
    return {
      datetime: moment().toISOString(),
      dialog: false,
      subjectGroup: null,
      teacher: null,
      academicLevels: [],
      type: '',
      time: moment().toISOString(),
      confirmDialog: false,
      typeList: [
        { title: 'Thỉnh giảng', value: 'short-term' },
        { title: 'Biên chế', value: 'long-term' },
        { title: 'Hợp đồng', value: 'short-term-contract' },
      ],
    }
  },
  props: {
    state: Boolean,
  },
  computed: {
    ...mapState('teacherAttendance', ['date']),
    getCurrentDate() {
      return moment(this.date).format('DD/MM/YYYY')
    },
    teacherFilter() {
      const filters = {
        subjectGroup: get(this.subjectGroup, 'id'),
        type: this.type,
        status: 'active',
      }
      if (Array.isArray(this.academicLevels) && this.academicLevels.length) {
        filters.academicLevels_in = this.academicLevels.map(a => a.id)
      }
      return filters
    },
  },
  methods: {
    ...mapActions('teacherAttendance', ['getAllTeacherAttendance', 'checkinTeacherAttendance']),
    cancel() {
      this.dialog = false
    },
    academicLevelChanged(academicLevels) {
      this.academicLevels = academicLevels
      this.teacher = null
    },
    subjectGroupChanged(subjectGroup) {
      this.subjectGroup = subjectGroup
      this.teacher = null
    },
    openConfirmDialog() {
      if (!this.$refs.form.validate() || !this.$refs.selectForm.validate()) {
        return
      }
      this.confirmDialog = !this.confirmDialog
    },
    async save() {
      if (!this.$refs.form.validate() || !this.$refs.selectForm.validate()) {
        return
      }
      try {
        this.$loading.active = true
        const datetime = moment(this.time)
          .date(moment(this.datetime).date())
          .month(moment(this.datetime).month())
          .year(moment(this.datetime).year())
          .toISOString()

        const dateGte = moment(datetime).startOf('day').toISOString()
        const dateLte = moment(datetime).endOf('day').toISOString()
        const teacherAttendances = await this.getAllTeacherAttendance({
          searchParams: {
            teacher: this.teacher.id,
            date_gte: dateGte,
            date_lte: dateLte,
          },
          disableSave: true,
        })
        const teacherAttendance = teacherAttendances[0]
        if (teacherAttendance) {
          if (teacherAttendance.status === 'attendance') {
            this.$alert.error('Giáo viên này đã đến trường')
            return
          }
          if (teacherAttendance.status === 'left' && moment(datetime).isSameOrBefore(moment(teacherAttendance.time))) {
            this.$alert
              .error('Thời gian không hợp lệ giáo viên này đã rời trường lúc ' + moment(teacherAttendance.time).format('HH:mm'))
            return
          }
        }
        await this.checkinTeacherAttendance({
          teacherId: this.teacher.id,
          time: datetime
        })
        this.$emit('addNewTeacherAttendance')
        this.$alert.success('Thêm điểm danh thành công')
        this.reset()
        this.dialog = false
      } catch (error) {
        this.$alert.addError()
      } finally {
        this.$loading.active = false
      }
    },
    reset() {
      this.subjectGroup = null
      this.teacher = null
      this.academicLevels = []
      this.type = null
      this.time = moment().toISOString()
    }
  },
  watch: {
    state() {
      this.dialog = true
    },
    dialog(newVal) {
      if (newVal) {
        this.reset()
      }
    },
  },
}
</script>
